import { AxiosInstance } from 'axios';
import config from 'config/Config';
import { initAxios } from 'utils/axios';
import { Form } from 'utils/customTypes';

class FormV2API {
  instance: AxiosInstance;
  constructor() {
    this.instance = initAxios(`${config.get('backendURL')}v2/forms`);
  }

  duplicateJsonSchemaForm = async (formId: string, title: string) => {
    const { data } = await this.instance.post(`/${formId}/duplicate`, {
      name: title,
    });
    const { id, attributes } = data.data;
    return {
      id,
      title: attributes.name,
      form_creator_id: attributes.formCreatorId,
      form_description: attributes.formDescription,
      request_type: attributes.requestType,
      status: attributes.status,
      organization_id: attributes.organizationId,
      isJsonSchema: attributes.isJsonSchema,
    } as Form;
  };

  deleteForm = async (formId: string) => {
    const { data } = await this.instance.delete(`/${formId}`);
    return data;
  };
}

const formV2API = new FormV2API();

export default formV2API;
